import { i18n } from "@/utils/i18n";
import { getMessageList } from "@/api/message";
import { getBannerList } from "@/api/banner";
const state = {
  messageType: [
    {
      name: i18n.t("綜合"),
      recent_type: "",
    },
    {
      name: i18n.t("公告"),
      recent_type: "1",
    },
    {
      name: i18n.t("活動"),
      recent_type: "2",
    },
    {
      name: i18n.t("更新"),
      recent_type: "3",
    },
  ],
  messageList: [],
  messageSwiper: [],
};
const mutations = {
  SET_MESSAGELIST(state, data) {
    state.messageList = data;
  },
  SET_HONE_MESSAGE_SWIPER(state, data) {
    state.messageSwiper = data;
  },
};
const actions = {
  async getMessage({ commit }, data) {
    const res = await getMessageList(data);
    commit("SET_MESSAGELIST", res.data.results);
  },
  async getBannerList({ commit }, data) {
    const res = await getBannerList(data);
    commit("SET_HONE_MESSAGE_SWIPER", res.data.results);
  },
};
export default {
  state,
  mutations,
  actions,
};
